<template>
  <v-container class="ma-0 pa-0 reportContainer">
    <!-- Header -->
    <v-row>
      <v-col class="ml-4"> </v-col>
      <v-col class="text-center"> </v-col>
      <v-col class="text-right mr-2">
        <v-btn @click="navToProjectPage" dark large class="">Back to Project</v-btn>
      </v-col>
    </v-row>
    <v-sheet elevation="2" class="ma-2 reportPage rounded">
      <v-sheet color="grey" class="text--white pb-2">
        <v-row>
          <v-col class="py-0">
            <img src="@/assets/images/customerLogo.png" />
          </v-col>
          <v-col class="text-right mr-10 pr-5 pt-10">
            <img width="150" src="@/assets/images/sigfloLogoTempDark.png" /><br />
            www.sigflo.com
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0 pl-10 white--text">
            Craig Craigerson<br />
            Totally Simulated CC<br />
            P: 123.123.1234<br />
            E: craigers@simulated.com<br />
            Budget: $400k<br />
          </v-col>
          <v-col class="py-0 white--text">
            Date: January 1, 2023<br />
            Invoice: INV-123294
          </v-col>
        </v-row>
      </v-sheet>
      <v-sheet class="pt-15 pl-5">
        <div class="text-center text-h4 mb-5">Jan 2023 Sanctuary Build</div>
      </v-sheet>
    </v-sheet>

    <v-sheet elevation="2" class="ma-2 pa-2 reportPage rounded">
      <div>
        <div class="ml-5 mt-8 text-h4">
          <v-avatar size="56px">
            <img alt="System Name" src="@/assets/images/splash_3.png" />
          </v-avatar>
          Audio Systems
        </div>
      </div>
      <v-divider class="mb-15 mt-2" />
      <v-sheet class="pl-5 pt-3">
        <div>
          Congratulations on designing a fully functional Audio system! Below you will find all of the Audio
          Disciplines, with the equipment/ interconnects that you have put together.
        </div>
        <v-row>
          <v-col>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left consoleTableInput">Console Input</th>
                    <th class="text-left consoleTableName">Name</th>
                    <th class="text-left">Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in consoleInputs" :key="item.index">
                    <td class="consoleTableInput">
                      <v-chip>{{ item.input }}</v-chip>
                    </td>
                    <td class="consoleTableName">{{ item.name }}</td>
                    <td class="consoleTableNotes text-caption">
                      {{ item.notes }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left consoleTableInput">Console Output</th>
                    <th class="text-left consoleTableName">Name</th>
                    <th class="text-left">Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in consoleOutputs" :key="item.index">
                    <td class="consoleTableInput">
                      <v-chip>{{ item.input }}</v-chip>
                    </td>
                    <td class="consoleTableName">{{ item.name }}</td>
                    <td class="consoleTableNotes text-caption">
                      {{ item.notes }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-sheet>
    </v-sheet>

    <v-sheet elevation="2" class="ma-2 pa-2 reportPage rounded">
      <div>
        <div class="ml-5 mt-8 text-h4">
          <v-avatar size="56px">
            <img alt="System Name" src="@/assets/images/splash_3.png" />
          </v-avatar>
          Audio Systems (cont'd)
        </div>
      </div>

      <v-divider class="mb-15 mt-2" />
      <v-sheet class="pl-5 pt-3">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="productTableImage"></th>
                <th class="productTableDescription">Product</th>
                <th class="productTablePrice">Price</th>
                <th class="productTableStatus">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in audioProducts" :key="item.index">
                <td class="productTableImage">
                  <v-avatar size="32px">
                    <img :src="item.imageName" />
                  </v-avatar>
                </td>
                <td class="productTableDescription">{{ item.description }}</td>
                <td class="productTablePrice">{{ item.price }}</td>
                <td class="productTableStatus">{{ item.status }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-sheet>
    </v-sheet>

    <v-sheet elevation="2" class="ma-2 pa-2 reportPage rounded">
      <div>
        <div class="ml-5 mt-8 text-h4">
          <v-avatar size="56px">
            <img alt="System Name" src="@/assets/images/splash_2.png" />
          </v-avatar>
          Project Summary
        </div>
      </div>

      <v-divider class="mb-15 mt-2" />
      <v-sheet class="px-5 pt-3">
        <div>
          Congratulations! You have successfully created a complete and congruent Audio system. From Source, to cable,
          to destination, you are all set to rock out and make beautiful sound!
        </div>
        <v-divider class="mb-5" />
        <v-card max-width="475" class="mx-auto">
          <v-toolbar color="primary" dark elevation="0">
            <v-toolbar-title>Budget Breakdown</v-toolbar-title>
          </v-toolbar>
          <v-list two-line subheader>
            <v-subheader>BUDGET BREAKDOWN ACROSS ALL SYSTEMS</v-subheader>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr v-for="item in projectTotals" :key="item.index">
                    <td class="totalsDescription text-right">
                      {{ item.description }}
                    </td>
                    <td class="totalsAmount">
                      {{ !item.amount || isNaN(item.amount) ? item.amount : formatPrice(item.amount) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-list>
        </v-card>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    data() {
      return {
        projectTotals: [
          { description: 'Audio Equipment', amount: 155868.81 },
          { description: 'Video Equipment', amount: 60166.71 },
          { description: 'Audio Equipment', amount: 109718.93 },
          { description: '', amount: '' },
          { description: 'Tax', amount: 'EXEMPT' },
          { description: 'Shipping Estimate', amount: 6500 },
          { description: '', amount: '' },
          { description: 'GRAND TOTAL', amount: 399619.44 }
        ],
        audioProducts: [
          {
            imageName: 'https://ttkdevimages.blob.core.windows.net/productimages/2.jpg',
            description: 'Allen & Heath Magical SQ-7 Console',
            price: 4999.0,
            status: 'In Stock'
          },
          {
            imageName: 'https://ttkdevimages.blob.core.windows.net/productimages/19.jpg',
            description: 'Allen & Heath Dust Cover for SQ-7 Mixer',
            price: 79.0,
            status: 'In Stock'
          },
          {
            imageName: 'https://ttkdevimages.blob.core.windows.net/productimages/8.jpg',
            description: 'Allen & Heath DT168 16x8 Dante/AES67 Audio I/O Expander',
            price: 1799.0,
            status: 'In Stock'
          },
          {
            imageName: 'https://ttkdevimages.blob.core.windows.net/productimages/9.jpg',
            description: 'Whirlwind ENC6SE etherCON Shielded Tactical Cat6 Cable (2 ft)',
            price: 68.74,
            status: 'Special Order (7-10 business days)'
          }
        ],
        consoleInputs: [
          {
            input: 'INPUT 01',
            name: 'KICK',
            notes: 'This may be the best kick input we have ever worked with.'
          },
          { input: 'INPUT 02', name: 'SNARE TOP', notes: '' },
          { input: 'INPUT 03', name: 'SNARE BOT', notes: '' },
          { input: 'INPUT 04', name: 'HI HAT', notes: '' },
          { input: 'INPUT 05', name: 'TOM 01', notes: '' },
          { input: 'INPUT 06', name: 'TOM 02', notes: '' },
          { input: 'INPUT 07', name: 'TOM 03', notes: '' },
          { input: 'INPUT 08', name: 'OVERHEAD L', notes: '' },
          { input: 'INPUT 09', name: 'OVERHEAD R', notes: '' },
          { input: 'INPUT 10', name: 'BASS', notes: '' },
          { input: 'INPUT 11', name: 'ACOUSTIC', notes: '' },
          { input: 'INPUT 12', name: 'ELEC. 01', notes: '' },
          { input: 'INPUT 13', name: 'ELEC. 02', notes: '' },
          { input: 'INPUT 14', name: 'KEYS LEFT', notes: '' },
          { input: 'INPUT 15', name: 'TRAX LEFT', notes: '' },
          { input: 'INPUT 16', name: 'TRAX RIGHT', notes: '' },
          { input: 'INPUT 17', name: 'VOCAL 01', notes: '' },
          { input: 'INPUT 18', name: 'VOCAL 02', notes: '' },
          { input: 'INPUT 19', name: 'VOCAL 03', notes: '' },
          { input: 'INPUT 20', name: 'VOCAL 03', notes: '' },
          { input: 'INPUT 21', name: 'VOCAL 04', notes: '' },
          { input: 'INPUT 22', name: 'VOCAL 05', notes: '' },
          { input: 'INPUT 23', name: 'VOCAL 06', notes: '' },
          { input: 'INPUT 24', name: 'SPEAKER 01', notes: '' },
          { input: 'INPUT 25', name: 'SPEAKER 02', notes: '' },
          { input: 'INPUT 26', name: 'GRAPHICS LEFT', notes: '' },
          { input: 'INPUT 27', name: 'GRAPHICS RIGHT', notes: '' },
          { input: 'INPUT 28', name: 'MUSIC LEFT', notes: '' },
          { input: 'INPUT 29', name: 'MUSIC RIGHT', notes: '' },
          { input: 'INPUT 30', name: '', notes: '' },
          { input: 'INPUT 31', name: '', notes: '' },
          { input: 'INPUT 32', name: '', notes: '' }
        ],
        consoleOutputs: [
          { input: 'OUTPUT 01', name: 'IEM 01 LEFT', notes: '' },
          { input: 'OUTPUT 02', name: 'IEM 01 RIGHT', notes: '' },
          { input: 'OUTPUT 03', name: 'IEM 02 LEFT', notes: '' },
          { input: 'OUTPUT 04', name: 'ITEM 02 RIGHT', notes: '' },
          { input: 'OUTPUT 05', name: 'ITEM 03 LEFT', notes: '' },
          { input: 'OUTPUT 06', name: 'ITEM 03 RIGHT', notes: '' },
          { input: 'OUTPUT 07', name: 'ITEM 04 LEFT', notes: '' },
          { input: 'OUTPUT 08', name: 'ITEM 04 RIGHT', notes: '' },
          { input: 'OUTPUT 09', name: '', notes: '' },
          { input: 'OUTPUT 10', name: '', notes: '' },
          { input: 'OUTPUT 11', name: '', notes: '' },
          { input: 'OUTPUT 12', name: '', notes: '' },
          { input: 'OUTPUT 13', name: '', notes: '' },
          { input: 'OUTPUT 14', name: 'MAIN LEFT', notes: '' },
          { input: 'OUTPUT 15', name: 'MAIN RIGHT', notes: '' },
          {
            input: 'OUTPUT 16',
            name: 'MAIN SUB',
            notes: 'Most important output since it haz the bass'
          }
        ]
      };
    },
    computed: {
      ...mapState(['configurator'])
    }
  };
</script>

<style scoped>
  .reportContainer {
    background-color: #f2f2f2;
  }
  .reportPage {
    min-height: 1000px;
  }
  .consoleTableInput {
    width: 120px;
  }
  .consoleTableName {
    width: 180px;
  }
  .productTablePrice {
    width: 180px;
  }
  .productTableStatus {
    width: 180px;
  }
</style>
